// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IAccountReportDto
 */
export interface IAccountReportDto {
    /**
     * 
     * @type {number}
     * @memberof IAccountReportDto
     */
    account_id?: number;
    /**
     * 
     * @type {string}
     * @memberof IAccountReportDto
     */
    account_description?: string;
    /**
     * 
     * @type {string}
     * @memberof IAccountReportDto
     */
    account_number?: string;
    /**
     * 
     * @type {string}
     * @memberof IAccountReportDto
     */
    type?: IAccountReportDtoTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof IAccountReportDto
     */
    our_balance?: number;
    /**
     * 
     * @type {number}
     * @memberof IAccountReportDto
     */
    bank_balance?: number;
    /**
     * 
     * @type {number}
     * @memberof IAccountReportDto
     */
    difference?: number;
    /**
     * 
     * @type {number}
     * @memberof IAccountReportDto
     */
    prior?: number;
    /**
     * 
     * @type {number}
     * @memberof IAccountReportDto
     */
    delta?: number;
    /**
     * 
     * @type {number}
     * @memberof IAccountReportDto
     */
    credit?: number;
    /**
     * 
     * @type {number}
     * @memberof IAccountReportDto
     */
    debit?: number;
    /**
     * 
     * @type {string}
     * @memberof IAccountReportDto
     */
    close_date?: string;
}

/**
* @export
* @enum {string}
*/
export enum IAccountReportDtoTypeEnum {
    HSA = 'HSA',
    HCFSA = 'HCFSA',
    HRA = 'HRA',
    DCAP = 'DCAP',
    EXTERNAL = 'EXTERNAL',
    CLEARING = 'CLEARING',
    SUB_ACCOUNT = 'SUB_ACCOUNT',
    OMNIBUS = 'OMNIBUS',
    PARKING = 'PARKING',
    TRANSIT = 'TRANSIT',
    ADOPTION = 'ADOPTION',
    SPECIALTY = 'SPECIALTY',
    LIFESTYLE = 'LIFESTYLE',
    WAGEPARITY = 'WAGEPARITY',
    PLAN_OMNIBUS = 'PLAN_OMNIBUS',
    NOTIONAL_PAYROLL = 'NOTIONAL_PAYROLL',
    NOTIONAL_FUNDING = 'NOTIONAL_FUNDING',
    TRAVEL = 'TRAVEL'
}


/**
 * Check if a given object implements the IAccountReportDto interface.
 */
export function instanceOfIAccountReportDto(value: object): value is IAccountReportDto {
    return true;
}

export function IAccountReportDtoFromJSON(json: any): IAccountReportDto {
    return IAccountReportDtoFromJSONTyped(json, false);
}

export function IAccountReportDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IAccountReportDto {
    if (json == null) {
        return json;
    }
    return {
        
        'account_id': json['account_id'] == null ? undefined : json['account_id'],
        'account_description': json['account_description'] == null ? undefined : json['account_description'],
        'account_number': json['account_number'] == null ? undefined : json['account_number'],
        'type': json['type'] == null ? undefined : json['type'],
        'our_balance': json['our_balance'] == null ? undefined : json['our_balance'],
        'bank_balance': json['bank_balance'] == null ? undefined : json['bank_balance'],
        'difference': json['difference'] == null ? undefined : json['difference'],
        'prior': json['prior'] == null ? undefined : json['prior'],
        'delta': json['delta'] == null ? undefined : json['delta'],
        'credit': json['credit'] == null ? undefined : json['credit'],
        'debit': json['debit'] == null ? undefined : json['debit'],
        'close_date': json['close_date'] == null ? undefined : json['close_date'],
    };
}

export function IAccountReportDtoToJSON(json: any): IAccountReportDto {
    return IAccountReportDtoToJSONTyped(json, false);
}

export function IAccountReportDtoToJSONTyped(value?: IAccountReportDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'account_id': value['account_id'],
        'account_description': value['account_description'],
        'account_number': value['account_number'],
        'type': value['type'],
        'our_balance': value['our_balance'],
        'bank_balance': value['bank_balance'],
        'difference': value['difference'],
        'prior': value['prior'],
        'delta': value['delta'],
        'credit': value['credit'],
        'debit': value['debit'],
        'close_date': value['close_date'],
    };
}

